import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACCESS_KEY_QUERY, REVOKE_ACCESS_KEY_MUTATION, KEY_GENERATION_MUTATION, DELETE_ACCESS_KEY_MUTATION, RENEW_ACCESS_KEY_MUTATION } from "../../Queries/accessKey";
import { client } from "../..";
import { createSlice } from "@reduxjs/toolkit";


export const GenrateAccessKeys = createAsyncThunk(
  "accessKeys/generate",
  async ({ employeeId, sysName, sysOS }, { rejectWithValue }) => {
    try {
    
      const { data } = await client.mutate({
        mutation: KEY_GENERATION_MUTATION,
        variables: { employeeId: employeeId, sysName: sysName, sysOS: sysOS },
        fetchPolicy: "network-only",
      });

      return data;
    } catch (error) {
      console.error("Error fetching edit history:", error);
      return rejectWithValue(error.message || "Failed to fetch edit history");
    }
  }
);



export const fetchAccessKeys = createAsyncThunk(
  "employee/FetchEditHistory",
  async ({ page }, { rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: ACCESS_KEY_QUERY,
        variables: { pageNumber: page?.current },
        fetchPolicy: "network-only",
      });

      return data;
    } catch (error) {
      console.error("Error fetching edit history:", error);
      return rejectWithValue(error.message || "Failed to fetch edit history");
    }
  }
);

export const revokeAccessKeyThunk = createAsyncThunk(
  "accessKeys/revoke",
  async ({ key }, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: REVOKE_ACCESS_KEY_MUTATION,
        variables: { key },
      });

      return data.revokeAccessKey;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const deleteAccessKeyThunk = createAsyncThunk(
  "accessKeys/delete",
  async ({ key }, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: DELETE_ACCESS_KEY_MUTATION,
        variables: { key },
      });

      return data.deleteAccessKey;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  data: {
    records: [],
    totalCount: 0,
  },
  loading: false,
  error: null,
};

const desktopAccessKeysSlice = createSlice({
  name: "desktopAccessKeys",
  initialState,
  reducers: {
    // optional manual setter
    setAccessKeys(state, action) {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccessKeys.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAccessKeys.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.appAccessKeys;
      })
      .addCase(GenrateAccessKeys.fulfilled, (state, action) => {
        const newKey = action.payload?.KeyGenration;

        if (!newKey) return;

        // ensure structure exists
        if (!state.data) {
          state.data = { records: [], totalCount: 0 };
        }

      state.data.records.unshift(newKey);
        state.data.totalCount += 1;
      })
    }
  });

export const { setAccessKeys } = desktopAccessKeysSlice.actions;
export default desktopAccessKeysSlice.reducer;